import type { GalleryPlaceholder, NewbornGuide } from "../types";
import newbornAwakeImage from "../../../assets/images/newborn-awake-pink-wrap-portrait.webp";
import newbornGreenImage from "../../../assets/images/newborn-green-stroller-portrait.webp";
import newbornBearImage from "../../../assets/images/newborn-sleeping-bear-portrait.webp";
import newbornSafetyImage from "../../../assets/images/newborn-photography-safety-supported-pose.webp";
import inHomeNewbornImage from "../../../assets/images/newborn-twins-heart-prop-portrait.webp";

export const newbornGuides: NewbornGuide[] = [
  {
    eyebrow: "SESSION TIMING",
    title: "Best Age for Newborn Photos",
    description: "When is the ideal time for a newborn session?",
    href: "/resources/newborn/best-age-for-newborn-photos/",
    imageAlt: "Awake newborn baby wrapped in soft pink fabric",
    imageSrc: newbornAwakeImage,
    tone: "peach",
  },
  {
    eyebrow: "THE EXPERIENCE",
    title: "What Happens During a Newborn Session",
    description: "A step-by-step look at how the session flows.",
    href: "/resources/newborn/what-happens-during-a-newborn-session/",
    imageAlt: "Sleeping newborn baby posed in a green wooden stroller",
    imageSrc: newbornGreenImage,
    tone: "cream",
  },
  {
    eyebrow: "PHOTO DAY",
    title: "How to Prepare for Your Newborn Session",
    description: "Everything you need to know to get ready.",
    href: "/resources/newborn/how-to-prepare-for-your-newborn-session/",
    imageAlt: "Sleeping newborn baby in a warm bear-themed portrait",
    imageSrc: newbornBearImage,
    tone: "sand",
  },
  {
    eyebrow: "IN-HOME EXPERIENCE",
    title: "In-Home Newborn Photography: What Parents Should Know",
    description: "How an in-home newborn session works and what your family needs to prepare.",
    href: "/resources/newborn/in-home-newborn-photography/",
    imageAlt: "Sleeping newborn twins wrapped in neutral blankets inside a heart-shaped prop",
    imageSrc: inHomeNewbornImage,
    tone: "cream",
  },
  {
    title: "What If My Baby Doesn't Sleep?",
    description: "Tips for a calm and successful session.",
    href: "/resources/newborn/what-happens-during-a-newborn-session/#baby-awake",
    tone: "blush",
  },
  {
    eyebrow: "BABY SAFETY",
    title: "Is Newborn Photography Safe? What Parents Should Know",
    description: "How gentle posing, hands-on support and composite images keep comfort first.",
    href: "/resources/newborn/newborn-photography-safety/",
    imageAlt: "Newborn baby safely supported by several adult hands during a posed portrait",
    imageSrc: newbornSafetyImage,
    tone: "rose",
  },
  {
    title: "Twins Newborn Photography",
    description: "Special tips for photographing twins.",
    href: "/resources/newborn/twins-newborn-photography/",
    tone: "rose",
  },
  {
    title: "What to Bring to Your Newborn Session",
    description: "A helpful checklist for parents.",
    href: "/resources/newborn/what-to-bring/",
    tone: "blush",
  },
  {
    title: "Can My Baby Be Older Than Two Weeks?",
    description: "What to expect and how we adapt the session.",
    href: "/resources/newborn/can-my-baby-be-older-than-two-weeks/",
    tone: "peach",
  },
];

export const newbornGallery: GalleryPlaceholder[] = [
  { tone: "peach", label: "Newborn portrait one" },
  { tone: "cream", label: "Newborn portrait two" },
  { tone: "rose", label: "Newborn portrait three" },
  { tone: "blush", label: "Newborn portrait four" },
  { tone: "sand", label: "Newborn portrait five" },
];
